import React from "react";

let SERVER_HOST = "http://localhost:8000/engine.php";
// let SERVER_HOST = 'https://cocktail-4.e-menu.in.ua/shef/backend/engine.php';
if (process.env.NODE_ENV === "production")
    SERVER_HOST = "/shef/backend/engine.php";

export const dataContext = React.createContext();

//no-repeat url(./bg_0.svg) 100% top,
const THEME_0 = {
    "--background": `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bg_1.svg), linear-gradient(340deg, #b3d8d8 -27.16%, #a2d6d7 100%)`,
    "--navbar-bg-color": "#ABD7D8",
    "--navbar-tx-color": "#000000",

    "--item-bg-color": "#ffffff44",
    "--item-border-color": "#ffffff00",
    "--item-border-radius": "2rem",

    "--dark-btn-color": "#6c757d",
    "--dark-btn-border-color": "#6c757d",
    "--dark-btn-border-radius": "2rem",
    "--dark-btn-tx-color": "#ffffff",
    "--dark-btn-hover-color": "#60686f",
    "--dark-btn-tx-hover-color": "#ffffff",
};

export { SERVER_HOST, THEME_0 };
